import styled from 'styled-components';

export const Container = styled.div.attrs(() => ({
  className: 'SettingsTeacherProfileContainer',
}))`
  max-width: 960px;
  margin: 20px auto;

  .breadcrumbs-container {
    padding-bottom: 15px;
  }

  #teacherProfileTabs {
    max-width: 320px;
    padding: 20px 20px 0px;

    ${({ theme }) => theme.breakPoints.tablet} {
      padding: 20px 32px 0px;
    }

    .legoTabsItem{
      font-weight: bold;
    }
    > div {
      font-size: 16px;
      font-weight: normal;
    }
  }

  ${({ theme }: any) => theme.breakPoints.tablet} {
    width: 95%;

    .breadcrumbs-container {
      padding-bottom: 0;
    }
  }
`;

export const ContentContainer = styled.div.attrs(() => ({
  className: 'SettingsTeacherProfileContentContainer',
}))`
  background-color: #ffffff;
  box-shadow: rgb(0 0 0 / 8%) 0px 2px 4px 0px;
`;
